module.exports = __webpack_public_path__ + "fonts/087e5c21-3358-4cf3-9d2c-289a03a48292.83eb18d7.eot";